import { ElementState, Preview } from "@creatomate/preview";
import { Subtitle, SubtitleSection } from "chq";
import isSubtitleText from "./isSubtitleText";

const updatedSection = (
  subtitle: Subtitle, section: SubtitleSection, element: ElementState
): SubtitleSection => {
  const updatedSection = {
    ...section,
    hidden: false,
    startTime: parseFloat(element.globalTime.toFixed(3)),
    endTime: parseFloat((element.globalTime + element.duration).toFixed(3))
  };
  if (!subtitle.active) return updatedSection;

  return { ...updatedSection, text: element.source.text };
};

const updateActiveSubtitle = (
  element: ElementState,
  activeSubtitle: Subtitle,
  subtitles: Subtitle[],
  handleUpdateData: (newData: Record<string, any>) => void
) => {
  const newActiveSubtitleIndex = subtitles.findIndex(
    subtitle => !!subtitle.sections?.find(section => section.text === element.source.text)
  );

  // unselect previous active language and select new active language
  handleUpdateData({
    subtitles: subtitles.map((subtitle, index) => {
      if (activeSubtitle.id === subtitle.id) return { ...activeSubtitle, active: false };
      if (index === newActiveSubtitleIndex) return { ...subtitle, active: true };
      return subtitle;
    })
  });
};

const syncSubtitles = (
  handleUpdateData: (newData: Record<string, any>) => void,
  preview: Preview,
  subtitles: Subtitle[]
): void => {
  const subtitleElements = preview.state?.elements?.filter(
    element => isSubtitleText(element.source.name)
  ) || [];
  const activeSubtitle = subtitles.find(subtitle => subtitle.active);
  let subtitlesResult = [...subtitles];
  subtitleElements.forEach(element => {
    // name format sub-INDEX-creatomateId
    const match = element.source.name.match(/sub-(\d{1,4})-/);
    const sectionIndex = parseInt(match[1], 10);

    // update active subtitle if need it, just when the first element text does not match
    // and you have more languages available
    if (
      activeSubtitle
      && sectionIndex === 0
      && (activeSubtitle?.sections || [])[0]?.text !== element.source.text
      && subtitles.length > 1
    ) {
      updateActiveSubtitle(element, activeSubtitle, subtitles, handleUpdateData);
    }

    subtitlesResult = [...subtitlesResult.map(subtitle => {
      const updatedSections = subtitle.sections?.map(section => (section.index === sectionIndex
        ? updatedSection(subtitle, section, element) : section
      ));
      return { ...subtitle, sections: updatedSections };
    })];
  });

  handleUpdateData({ subtitles: subtitlesResult });
};

export default syncSubtitles;
